import React from 'react';
import { notification, Typography } from 'antd';

const { Text } = Typography;

class Notifications {
	static onlyJPGFilesAllowed() {
		const description = (
			<Text>Only JPEG/JPG files upto 20MB allowed.</Text>);
		notification.error({
			message: 'Wrong file format',
			description,
			placement: 'bottomLeft',
			bottom: 96
		});
	}
	static invalidFileFormat(fileName) {
		const description = (
			<Text>
				<Text code>{fileName}</Text>
				is not supported. Valid file formats are <Text code>png / jpg / jpeg</Text> upto 20mb;
			</Text>);
		notification.error({
			message: 'Invalid File Format',
			description,
			placement: 'bottomLeft',
			bottom: 96
		});
	}
	static JPGSavedAsPNG(fileName) {
		const description = (
			<Text>
				<Text code>{fileName}</Text>
				is a <Text code>JPG/JPEG</Text> file saved as
				<Text code> PNG</Text>. Please rename & upload with correct extension.
			</Text>);
		notification.error({
			message: 'JPG file saved as PNG.',
			description,
			placement: 'bottomLeft',
			bottom: 96,
			duration: 10
		});
	}
	static serverError(fileName) {
		const description = (
			<Text>
				A server error occurred during uploading or compressing <Text code>{fileName}</Text>.
			</Text>);
		notification.error({
			message: 'Server Error',
			description,
			placement: 'bottomLeft',
			bottom: 96,
			duration: 6
		});
	}
}

export default Notifications;




// WEBPACK FOOTER //
// ./src/components/Notifications.js